import React from "react"
import * as styles from "../hero/hero.module.scss"
import * as caseStyle from "../cases/cases.module.scss"
import * as blogStyle from "./blog.module.scss"
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";

const BlogHero = ({title, tags, date}) => {

    const breadcrumbs = [
        {
            "uri": "/blog/",
            "title": "Blog"
        }
    ]

    return (
        <section className={`${styles.hero} ${styles.heroSm} ${blogStyle.blogHero}`}>
            <div className="grid-container-wrap">
                <div className="grid-container">

                    <div className="grid-colstart-2-xl-min grid-colend-12-xl-min">
                        <Breadcrumbs breadcrumbs={breadcrumbs} pageTitle={title}/>

                        <h1 className={styles.heroTitle}><small>{date}<span className="sr-only">:</span>
                        </small><br/>{title}</h1>

                        {tags &&
                        <ol className={caseStyle.casesTagsList}>
                            {tags.map((tag, tagKey) => {
                                return <li key={`${tag.slug}-${tagKey + 1}`}><a
                                    href={`/blog/${tag.slug}`}>{tag.name}</a></li>;
                            })}
                        </ol>
                        }
                    </div>

                </div>
            </div>
        </section>
    )
}

export default BlogHero